import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipLoader } from 'react-spinners';
import brownzePackageImg from "../../../Asset/Membership/MembershipPackages/bronze-membership-card.svg";
import silverPackageImg from "../../../Asset/Membership/MembershipPackages/silver-membership-card.svg";
import goldPackageImg from "../../../Asset/Membership/MembershipPackages/gold-membership-card.svg";
import tickArrow from "../../../Asset/Membership/MembershipPackages/tick-arrow.svg";
import BuyNowButton from "../../../Asset/Membership/MembershipPackages/BuyNow-Button.svg";
import PaymentSuccessBackgroundImage from "../../../Asset/Events/paymentStatus/payment-success-banner.png"
import DownloadInvoiceButton from "../../../Asset/Events/paymentStatus/Download-invoice-button.svg"
import RetryPaymentButton from "../../../Asset/Events/paymentStatus/Retry-payment-button.svg"
import RedCrossPaymentFailure from "../../../Asset/Events/paymentStatus/red-cross-payment-failure.svg"
import { useSearchParams } from "react-router-dom";
// import plans from "razorpay/dist/types/plans";

const MembershipCard = ({ plan, image, description, discount, onBuy, isMobile = false }) => {
  return (
    <div className="relative w-full max-w-[380px] md:max-w-[470px] mx-auto">
      <img
        src={image}
        alt={`${plan.PlanTier} membership card`}
        className="w-full h-auto select-none pointer-events-none"
      />
      <div className={`absolute inset-0 flex flex-col ${isMobile ? 'gap-1 p-5' : 'gap-2 md:gap-3 p-6 md:p-7 lg:p-8'} text-[var(--dark-blue)]`}>
        <h1 className={`font-ClashGrotesk font-medium ${isMobile ? 'text-[1.4rem]' : 'text-[2rem]'}`}>
          {plan.PlanTier}
        </h1>
        <p className={`font-manrope font-[520] w-5/6 ${isMobile ? 'text-[0.75rem] leading-tight' : 'text-xl'}`}>
          {description}
        </p>
        <p className={`font-ClashGrotesk font-medium ${isMobile ? 'text-[1.8rem] mt-1' : 'text-[3.5rem]'}`}>
          ₹{plan.Price}
        </p>

        {/* Desktop view */}
        <div className="md:flex gap-2 items-center font-manrope mb-1  hidden">
          <span className="flex-shrink-0">
            <img src={tickArrow} alt="tick" />
          </span>
          <span className={`font-bold  ${isMobile ? 'text-[1.2rem]' : 'text-xl'}`}>
            {plan.Credits} Credits
          </span>
          <span className={`font-semibold text-[var(--light-purple-membership-package-card)] ${isMobile ? 'text-[0.9rem]' : 'text-base'}`}>
            at ₹{(plan.Price / plan.Credits).toFixed(2)}/credit
          </span>
        </div>
        <div className="hidden md:flex gap-2 items-start font-manrope mb-4">
          <span className="flex-shrink-0">
            <img src={tickArrow} alt="tick" />
          </span>
          <span className={`font-bold ${isMobile ? 'text-[1.2rem]' : 'text-xl'}`}>
            {discount}%
          </span>
          <span className={`font-semibold text-[var(--light-purple-membership-package-card)] ${isMobile ? 'text-[0.9rem]' : 'text-base'}`}>
            off non-member rates on events and play-pass!
          </span>
        </div>

        {/* Mobile view */}
        <div className="flex gap-2 items-start font-manrope mb-0.5 md:hidden">
          <span className="flex-shrink-0 mt-0.5">
            <img src={tickArrow} alt="tick" className="w-3.5 h-3.5" />
          </span>
          <span className={`font-bold  ${isMobile ? 'text-[0.85rem]' : 'text-xl'}`}>
            {plan.Credits} Credits {" "}
            <span className={`font-semibold text-[var(--light-purple-membership-package-card)] ${isMobile ? 'text-[0.7rem]' : 'text-base'}`}>
              at ₹{(plan.Price / plan.Credits).toFixed(2)}/credit
            </span>
          </span>

        </div>
        <div className="flex gap-2 items-start font-manrope md:hidden mb-2">
          <span className="flex-shrink-0 mt-0.5">
            <img src={tickArrow} alt="tick" className="w-3.5 h-3.5" />
          </span>
          <span className={`font-bold ${isMobile ? 'text-[0.85rem]' : 'text-xl'}`}>
            {discount}% <span className={`font-semibold text-[var(--light-purple-membership-package-card)] ${isMobile ? 'text-[0.7rem]' : 'text-base'}`}>
              off non-member rates on events and play-pass!
            </span>
          </span>

        </div>

        <button onClick={onBuy} className={`w-24 ${isMobile ? 'w-24' : ''}`}>
          <img src={BuyNowButton} alt="Buy Button" className="w-full" />
        </button>
      </div>
    </div>
  );
};

const MembershipPackages = ({ onOpenMembershipPackageModal }) => {
  const [planBronze, setPlanBronze] = useState([]); // State to store the response data
  const [planSilver, setPlanSilver] = useState([]); // State to store the response data
  const [planGold, setPlanGold] = useState([]); // State to store the response data
  const [loading, setLoading] = useState(false); // State to handle loading state
  const [error, setError] = useState(""); // State to handle errors

  // Use States for payment status view
  const [topBar, setTopBar] = useState(true);
  const [paymentSuccessView, setPaymentSuccessView] = useState(false);
  const [paymentFailureView, setPaymentFailureView] = useState(false);

  // Use States for payment status
  const [paymentData, setPaymentData] = useState(null); // State to store payment data
  const [storeSubOrderId, setStoreSubOrderId] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(true); // State to handle loading
  const [errorStatus, setErrorStatus] = useState(null); // State to handle errors

  const [invoiceBtnLoading, setInvoiceBtnLoading] = useState(false);

  //use States for retry button
  const [loadingRetryButton, setLoadingRetryButton] = useState(false);

  // qParams to search payment id 
  const [qParams] = useSearchParams()
  const payment_id = qParams.get('payment_id');

  // Fetch Payment Status and set payment status success and failure view
  useEffect(() => {
    if (!payment_id) {
      setErrorStatus('Payment ID is missing');
      setLoadingStatus(false);
      return;
    }

    const fetchPaymentStatus = async () => {
      try {
        setLoadingStatus(true);
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/payments/status/?payment_id=${payment_id}`
        ); // Include payment_id in API request


        setPaymentData(res.data); // Store the response data
        setLoadingStatus(false);
        setStoreSubOrderId(res.data.SubOrderId)

        // Payment Status conditions
        if (res.data.TransactionStatus === 'Success') {

          setPaymentSuccessView(true);
          setPaymentFailureView(false);

        } else {

          setPaymentSuccessView(false);
          setPaymentFailureView(true);

        }

      } catch (err) {
        setErrorStatus(err.message || 'An errorStatus occurred while fetching payment status');
        setLoadingStatus(false);
      }
    };

    fetchPaymentStatus();
  }, [payment_id]);


  // Fetch plans
  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true); // Start loader
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/plans/?page=1&page_size=10`);
        setPlanBronze(response.data[2]); // Save the response data in state
        setPlanSilver(response.data[1]); // Save the response data in state
        setPlanGold(response.data[0]); // Save the response data in state

        console.log("Consoling responses one by one")
        console.log(response.data[0])
        console.log(response.data[1])
        console.log(response.data[2])
      } catch (err) {
        console.error(err);
        setError("Failed to fetch plans. Please try again later.");
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchPlans(); // Call the function
  }, []);


  // Handle download invoice
  const handleDownloadInvoice = async (e) => {
    e.preventDefault(); // Prevent the default button click behavior
    setInvoiceBtnLoading(true)
    try {
      if (!payment_id) {
        console.error('Payment ID is not available');
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payments/${payment_id}/invoice`,
        {
          params: { payment_id }, // Send the stored payment_id as a query parameter
          responseType: 'blob', // Expect a file (Blob) in the response
        }
      );

      // Create a URL for the Blob and trigger the download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `NG-${payment_id}.pdf`); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      link.remove(); // Clean up the link element
    } catch (error) {
      console.error('Error downloading the invoice:', error);
      // alert('Failed to download the invoice. Please try again.');

    }
    setInvoiceBtnLoading(false)
  };

  // Handle payment retry
  const handleRetry = async (e) => {
    e.preventDefault();

    setLoadingRetryButton(true);

    try {
      const checkoutResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/checkout/?sub_order_id=${storeSubOrderId}`, // URL
        {}, // Data (empty object since no body is being sent)
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        } // Config (e.g., headers)
      );

      const { RazorpayOrderId, amount } = checkoutResponse.data;
      handleRazorpayPayment(RazorpayOrderId, amount);
    } catch (error) {
      console.error("Error during checkout:", error);
      // Optional: Handle specific error cases
    } finally {
      setLoadingRetryButton(false);
    }
  }

  // Handle Razorpay checkout
  const handleRazorpayPayment = async (RazorpayOrderId, amount) => {
    amount = amount * 100;
    //Dynamically create a form to submit to Razorpay Hosted Checkout
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute(
      "action",
      "https://api.razorpay.com/v1/checkout/embedded"
    );
    form.setAttribute("target", "_blank");

    //Define form fields dynamically
    const fields = [
      { name: "key_id", value: "rzp_test_w402YRQwCZ0zlG" }, // Your Razorpay key ID
      { name: "order_id", value: RazorpayOrderId }, // The order ID returned from backend
      { name: "amount", value: amount * 100 }, // Amount in paise (multiply INR by 100)
      { name: "currency", value: "INR" },

      { name: "name", value: "Net Gala" },
      { name: "description", value: "Please complete your payment to proceed." },
      { name: "image", value: `${process.env.REACT_APP_HOSTED_URL}/logo.png` }, // Company logo or product image
      // { name: "image", value: `http:/localhost:3000/logo.png` }, // Company logo or product image
      // { name: "image", value: `https://ibb.co/wM7K7Kc` }, // Company logo or product image
      {
        name: "callback_url",
        value: `${process.env.REACT_APP_BASE_URL}/payment/callback/`,
      },
      {
        name: "cancel_url",
        value: `${process.env.REACT_APP_BASE_URL}/payment/cancel`,
      },
      // { name: "prefill[name]", value: "name" }, // Optional pre-fill for name
      // { name: "prefill[contact]", value: "" }, // Optional pre-fill for contact
      // { name: "prefill[email]", value: "email" }, // Optional pre-fill for email
    ];

    //Append fields to the form
    fields.forEach(({ name, value }) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", value);
      form.appendChild(input);
    });

    // Append form to the body and submit it automatically
    document.body.appendChild(form);
    form.submit();



  };


  const handleOpenModalBronze = () => {
    const data = { PlanId: planBronze.PlanId, PlanTier: planBronze.PlanTier, Price: planBronze.Price }; // Example data
    onOpenMembershipPackageModal(data); // Send data to the parent
  };
  const handleOpenModalSilver = () => {
    const data = { PlanId: planSilver.PlanId, PlanTier: planSilver.PlanTier, Price: planSilver.Price }; // Example data
    onOpenMembershipPackageModal(data); // Send data to the parent
  };
  const handleOpenModalGold = () => {
    const data = { PlanId: planGold.PlanId, PlanTier: planGold.PlanTier, Price: planGold.Price }; // Example data
    onOpenMembershipPackageModal(data); // Send data to the parent
  };

  return (
    <div className="px-4 md:px-6 lg:px-8 pb-10">

      {/* payment Status here */}
      <div className={`pt-32 w-full ${topBar ? 'block' : 'hidden'}`}>

        {/* Payment Success */}
        <div className={`w-[full]  h-32 px-7 items-center justify-between ${paymentSuccessView ? 'flex' : 'hidden'}`} style={{
          backgroundImage: `url(${PaymentSuccessBackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <h1 className="font-manrope text-2xl text-[var(--white)] font-[450] ">Your payment is successful!</h1>

          <button onClick={handleDownloadInvoice} className="mr-6">
            <img src={DownloadInvoiceButton} alt="invoice button" />
          </button>

        </div>

        {/* Payment Failure */}
        <div className={`w-full bg-[#FFC9C9] h-32 px-7 items-center justify-between ${paymentFailureView ? 'flex' : 'hidden'}`}>

          <div className="flex gap-2">
            <span><img src={RedCrossPaymentFailure} alt="red cross vector" /></span>
            <span className="text-[#812121] font-manrope text-2xl font-[450]">Your transaction has failed</span>
          </div>

          <div className="mr-6">
            <button onClick={handleRetry} className=" flex justify-center">
              {loadingRetryButton ? (<ClipLoader color="white" size={20} />)
                : (<img src={RetryPaymentButton} alt="invoice button" />)}
            </button>

          </div>

        </div>

      </div>


      <div id="membership-heading" className="pt-12 md:pt-16 flex justify-center">
        <div className="font-ClashGrotesk text-[var(--dark-blue)] font-medium flex flex-col items-center">
          <h1 className="text-[2.5rem] md:text-[4.5rem]">Membership Tiers</h1>
          <p className="text-[1.75rem] md:text-[2.125rem]">Choose Your Adventure!</p>
        </div>
      </div>

      <div id="membership-packages" className="mt-8 md:mt-12">

        {/* Show loader while loading */}
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <ClipLoader size={50} color={"#2D1066"} loading={loading} />
          </div>
        ) : error ? (
          <p className="text-red-500">{error} Sorry! Could not load packages.</p>
        ) : (
          <>



            {/* For medium devices view here */}
            <div className="md:flex hidden justify-center w-full gap-4 md:gap-6">

              <MembershipCard
                plan={planBronze}
                image={brownzePackageImg}
                description="Perfect for those dipping their toes into a more active lifestyle."
                discount={50}
                onBuy={handleOpenModalBronze}
              />

              <MembershipCard
                plan={planSilver}
                image={silverPackageImg}
                description="Perfect for those dipping their toes into a more active lifestyle."
                discount={58}
                onBuy={handleOpenModalSilver}
              />

              <MembershipCard
                plan={planGold}
                image={goldPackageImg}
                description="Perfect for those dipping their toes into a more active lifestyle."
                discount={70}
                onBuy={handleOpenModalGold}
              />

            </div>



            {/* For mobile view here */}

            <div className="home-about-us-cards md:hidden carousel w-full md:mb-16 flex gap-4">
              <div className="carousel-item w-[82vw] md:w-[60vw]">
                <MembershipCard
                  plan={planBronze}
                  image={brownzePackageImg}
                  description="Perfect for those dipping their toes into a more active lifestyle."
                  discount={50}
                  onBuy={handleOpenModalBronze}
                  isMobile={true}
                />
              </div>

              <div className="carousel-item w-[82vw] md:w-[60vw]">
                <MembershipCard
                  plan={planSilver}
                  image={silverPackageImg}
                  description="Ideal for regulars aiming for the perfect balance of fitness and fun."
                  discount={58}
                  onBuy={handleOpenModalSilver}
                  isMobile={true}
                />
              </div>

              <div className="carousel-item w-[82vw] md:w-[60vw]">
                <MembershipCard
                  plan={planGold}
                  image={goldPackageImg}
                  description="Crafted for the elite, the dedicated, the game-changers."
                  discount={70}
                  onBuy={handleOpenModalGold}
                  isMobile={true}
                />
              </div>
            </div>
          </>

        )}

      </div>
    </div>
  );
};

export default MembershipPackages;